var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002868",
    d: "M54 40V0H.7v40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    stroke: "#000",
    d: "M49.8 14.6V22c0 5-2.5 10.3-8.7 13.3-6.3-3-8.8-8.3-8.8-13.3v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.9,
    d: "M49.8 14.6V22c0 5-2.5 10.3-8.7 13.3-6.3-3-8.8-8.3-8.8-13.3v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcad56",
    d: "M38 22.8q-.5.6-1 .4l-.9-1.3c-.3-.4-.4-.2-.6-.4l-1-.7q-.4 0-.7-.7 0-.3.4-.4.3-.1.3-.5 0-.3.4-.5l-.4-.1h-.7l.2-.2q0-.2.3-.2l.6-.2v-.3q-.5-.2-.2-.3l-.2-.2V17l.2-.5q-.2-.2 0-.5t.3-.1.5.3q.3.1.3.4t.4.4q.4 0 .5.7l.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 22.8q-.5.6-1 .4l-.9-1.3c-.3-.4-.4-.2-.6-.4l-1-.7q-.4 0-.7-.7 0-.3.4-.4.3-.1.3-.5 0-.3.4-.5l-.4-.1h-.7l.2-.2q0-.2.3-.2l.6-.2v-.3q-.5-.2-.2-.3l-.2-.2V17l.2-.5q-.2-.2 0-.5t.3-.1.5.3q.3.1.3.4t.4.4q.4 0 .5.7l.4.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa1a1",
    d: "m38.5 17.2.3.5q.2.1.2.4l.2.4.2.4v.5q.3.2.2.5v.8q.2.2 0 .5-.2.4-.6.5t-.3.6-.7.4q-.6.4-.7-.5 0-.7-.8-1.5-.7-1 .2-1.6c.5-.3.4-1.2.4-1.7q0-.8.6-1.2.6.4.8 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1b2dc",
    d: "M37.6 20.7q-.2-.2 0-1.1.4-.9.1-1.4v-.6l.2-.4q0-.2.2 0l-.1.5c-.2.3.4 1 .1 1.7q-.2 1 .2 1.7c0 .5.2 1.6-.5 1.8.4-.3 0-1.7-.2-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 20.6h.2q0-.2.2-.2l.3-.1.3-.2q0-.4.4-.6m.8-1.8q-.2 0-.5.3m-.9-1.6q.3 0 .3.3c.2.2 0 .4.2.4q.3 0 .1.3l.1.4m-1 .9q.2-.3.5-.4m-.6-.4h.6m-.6-.2.3-.2m-.5-.1.5-.1m-.7-.3.5-.1m-.3-.4h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "m44.7 18.4-1.4-1-1.3-1q.2-.2 1.6.7l1.3 1zm0 .4-1.5-.7c-.7-.3-1.8-.3-2-.4 0-.1 1.4-.2 2.3.2l1.4.7zm0 .7s-.9-.4-1.6-.5c-.7-.2-1.8-.1-1.9-.2s1.3-.3 2.3 0l1.4.5zm-.1.7q-.1-.2-1.4-.5c-.7 0-1.7.5-1.8.4 0 0 .8-.7 1.9-.6a3 3 0 0 1 1.5.5zm.2-2.3s-.7-.6-.7-1q.1-1 .6-1.1c0 .2-.4.6-.4 1s.8 1 .8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "m44.8 18 .2-1.2c0-.6-.5-1.2-.4-1.3.1.1.6.6.6 1.3l-.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    stroke: "#fcd116",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "m45 17.7-.2-.5q-.2-.3-.8-.2l-.7.5-.2 1.2V24l-.3.8.1-.8v-5.4q0-.7.2-1.2.4-.6 1-.7l.6.2q.4.3.4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "m45 17.7-.2-.5q-.2-.3-.8-.2l-.7.5-.2 1.2V24l-.3.8.1-.8v-5.4q0-.7.2-1.2.4-.6 1-.7l.6.2q.4.3.4.8zm0 5-.5 1q-.3.4-.5.3v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "M45.1 22.8s0 .6-.2 1q0 .6-.4.5-.2-.2 0-.5l.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "M45.3 22.8v1q0 .7-.4.7-.2-.1-.1-.6l.3-1.1zm.5-4.4 1.4-1 1.3-1q-.2-.2-1.6.7l-1.3 1zm0 .4 1.5-.7c.7-.3 1.8-.3 2-.4 0-.1-1.4-.2-2.3.2l-1.4.7zm0 .7s.9-.4 1.6-.5c.7-.2 1.8-.1 1.9-.2s-1.3-.3-2.3 0l-1.4.5zm.1.7q.1-.2 1.4-.5c.7 0 1.7.5 1.8.4 0 0-.8-.7-1.9-.6a3 3 0 0 0-1.5.5zm-.2-2.3s.7-.6.7-1q-.1-1-.6-1.1l.4 1c0 .4-.8 1-.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "m45.7 18-.2-1.2c0-.6.5-1.2.4-1.3-.1.1-.6.6-.6 1.3l.1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    stroke: "#fcd116",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "m45.5 17.7.2-.5q.2-.3.7-.2t.7.5q.3.6.2 1.2V24l.3.8-.1-.8v-5.4q0-.7-.2-1.2-.4-.6-1-.7l-.6.2q-.4.3-.4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "m45.5 17.7.2-.5q.2-.3.7-.2t.7.5q.3.6.2 1.2V24l.3.8-.1-.8v-5.4q0-.7-.2-1.2-.4-.6-1-.7l-.6.2q-.4.3-.4.8zm-.1 5 .6 1q.3.4.5.3t0-.6l-1-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "M45.4 22.8s0 .6.2 1q0 .6.4.5.2-.2 0-.5l-.4-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "M45.3 22.8v1q0 .7.3.7.2-.1.1-.6l-.3-1.1zm0 0q-.8-.1-.7-.2v-.4l-.2-.5v-.5l-.2-.4v-.5l-.1-.5v-1l.2-.5s.3-.6 1-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 20.5q-1.3-.1-1.1-.2m1-.3-1.1-.2m1.1-.3-1.1-.2m1.1-.3q-1.1-.1-1-.2m1-.2-.7-.1-.2-.2m1 4-.7-.1m.6-.2-.7-.2m.8-.3q-1 0-1-.3m1-.2c-1 0-1-.2-1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9e540a",
    d: "M45.3 22.8q.7-.1.6-.2v-.4l.2-.5v-.5l.2-.4v-.5l.1-.5v-1l-.2-.5s-.3-.6-1-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 20.5q1.1-.1 1-.2m-1-.3 1.1-.2m-1.1-.3 1.1-.2m-1.1-.3q1.1-.1 1-.2m-1-.2.7-.1.2-.2m-1 4 .7-.1m-.6-.2.7-.2m-.7-.3q.8 0 .8-.3m-.9-.2c1 0 1-.2 1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M41 32.4c-.4.4-1.2.1-1.5 0-.3 0-1-.3-1.2-.6-.6 0-.8-.7-.7-.9l.1-.7c.3-.2-.1-.4.1-.6s0-.5.2-.7-.1-.4.1-.6 0-.5.2-.6-.1-.5.2-.6c.3-.2 0-.5.3-.6s0-.4.2-.5.1-.4.3-.5q.2 0 .2-.4h1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 32.4c-.4.4-1.2.1-1.5 0-.3 0-1-.3-1.2-.6-.6 0-.8-.7-.7-.9l.1-.7c.3-.2-.1-.4.1-.6s0-.5.2-.7-.1-.4.1-.6 0-.5.2-.6-.1-.5.2-.6c.3-.2 0-.5.3-.6s0-.4.2-.5.1-.4.3-.5q.2 0 .2-.4h1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 25.2-.1.6c-.2.2 0 .4-.2.6l-.1.6c-.2.2 0 .4-.2.6s0 .4-.2.6l-.1.7c-.3.2 0 .4-.2.6s0 .5-.2.7c-.3.3 0 .5-.2.7l-.1.5q-.3.3-.1.4m2.2-6.6-.1.6q-.2.2 0 .6l-.1.5-.1.7-.1.6-.1.6c-.2.2.1.4 0 .7-.3.2 0 .4-.2.6v.6l-.1.7-.1.5-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M41 32.4c.5.4 1.4.1 1.7 0 .2 0 1-.3 1.2-.6.5 0 .7-.7.6-.9v-.7c-.3-.2.1-.4-.1-.6s0-.5-.2-.7.1-.4-.2-.6l-.2-.6c-.2-.1.2-.5-.1-.6-.3-.2 0-.5-.3-.6s0-.4-.3-.5 0-.4-.3-.5 0-.2-.2-.4h-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 32.4c.5.4 1.4.1 1.7 0 .2 0 1-.3 1.2-.6.5 0 .7-.7.6-.9v-.7c-.3-.2.1-.4-.1-.6s0-.5-.2-.7.1-.4-.2-.6l-.2-.6c-.2-.1.2-.5-.1-.6-.3-.2 0-.5-.3-.6s0-.4-.3-.5 0-.4-.3-.5 0-.2-.2-.4h-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1 25.2c.2.2 0 .3.2.6s0 .4.2.6-.1.3 0 .6c.3.2 0 .4.3.6l.1.6c.3.3 0 .4.2.7s0 .4.2.6 0 .5.2.7l.1.7c.2.2 0 .4.2.5l.1.4m-2.2-6.6c.2.3-.1.4 0 .6.3.2 0 .3.1.6l.1.5.1.7v.6c.3.3 0 .4.2.6v.7l.1.6.1.6.1.7v.5q.3.3.2.4m-1.7.1V25m0 .5v1l.1.8V29q-.1.4 0 .8c-.1.5.2.7 0 1s.2.4 0 .8c-.2.3.1.4 0 .8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M41.2 26.8q.2.1 0 .6v.7c-.1.3.2.6 0 .9q.2.4 0 1 .2.5 0 .9.2.1 0 .7c0 .5-.2.1-.1 0 .2-.4-.2-.5 0-.8s-.1-.5 0-1q-.2-.4 0-.8v-2.4c0-.4.2 0 .1.2m-.8.3v.6c-.2.2 0 .4-.2.6v1.2c-.2.2 0 .4-.2.7q-.2.3 0 .6c-.2.1 0 .6-.2.6q0 .3-.2.5v-.5c.3-.3 0-.5.2-.7v-.6l.1-.6.1-.7q.2-.2 0-.6c.3-.2 0-.3.2-.6V27l.1-.5c.3 0 .1.6 0 .7m-.6-.7v.6c-.2.2 0 .5-.2.7s0 .5-.2.6 0 .6-.2.7 0 .5-.2.7 0 .6-.2.7v.4l-.4.6.1-.5c.2-.2 0-.4.2-.7s0-.5.2-.7 0-.4.2-.6l.1-.7c.2-.2 0-.4.2-.6s0-.4.2-.6v-.6q.3-.2.2-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M39.6 25.3q-.2-3.1 1.5-3 1.5-.1 1.4 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M39.6 25.3q-.2-3.1 1.5-3a1 1 0 0 0-1 .8q0 .3.1.1v.3c-.1 0-.2.4 0 .3v.3l-.1.5q.2-.2 0 .2v.2q.3 0 0 .3zm2 0-.1-1.3q-.3-.4 0-.2t0-.1l-.2-.7.2.1q.2.2 0-.2 0-.3.2-.1c.4.2.6.7.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M41 25.6q-.7 0-1.2-.2t-.3-.4h.5a4 4 0 0 0 2.1 0h.6q0 .2-.3.4-.6.2-1.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0h26.6v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.8 0 14 7.5 24 0h3.3v2.6l-10 7.4 10 7.5V20H24l-10-7.5L4 20H.7v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18.3 11.7 9 6.6V20L16 11.7zm-7.6.8.2 1.5-8 6H.7zM27.3 0v.1L17 8V6l8.3-6zM.7 0l10 7.3H8L.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 0v20h6.7V0zM.7 6.7v6.6h26.6V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.7 8v4h26.6V8zM12 0v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTc);
export default __webpack_public_path__ + "static/media/tc.bfd2e308569530d2095dd736124ccbd1.svg";
export { ForwardRef as ReactComponent };